
import { useTranslation } from 'react-i18next';

export default function CTA() {
  const { t } = useTranslation();

  const scrollToOrder = () => {
    const element = document.getElementById('order');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-stone-50 relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="w-full h-[500px] rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/1681d69a5b156bf16fd7f9a96245b161/1d4ff0beda055cb25003de6000c60f2c.png"
                alt="MYSA Pilates Towel"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Content Side */}
          <div className="text-left">
            <h2 className="text-3xl md:text-4xl font-light text-stone-800 mb-6 leading-tight tracking-tight">
              {t('cta.title')}<br />{t('cta.titleLine2')}
            </h2>
            <p className="text-base text-stone-600 mb-8 leading-relaxed max-w-md">
              {t('cta.subtitle')}
            </p>
            <button
              onClick={scrollToOrder}
              className="bg-stone-800 text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-stone-700 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {t('cta.button')}
            </button>
            
            {/* Stats */}
            <div className="mt-12 flex gap-10">
              <div>
                <div className="text-2xl font-light text-stone-800">5,000+</div>
                <div className="text-stone-500 text-xs mt-1">{t('cta.practitioners')}</div>
              </div>
              <div>
                <div className="text-2xl font-light text-stone-800">100%</div>
                <div className="text-stone-500 text-xs mt-1">{t('cta.ecoFriendly')}</div>
              </div>
              <div>
                <div className="text-2xl font-light text-stone-800">4.9★</div>
                <div className="text-stone-500 text-xs mt-1">{t('cta.rating')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
